import { render, staticRenderFns } from "./collectperson.vue?vue&type=template&id=4e551d15&scoped=true"
import script from "./collectperson.vue?vue&type=script&lang=js"
export * from "./collectperson.vue?vue&type=script&lang=js"
import style0 from "./collectperson.vue?vue&type=style&index=0&id=4e551d15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e551d15",
  null
  
)

export default component.exports